// extracted by css-extract-rspack-plugin
export default {"middlePaneWrapper":"MilestoneCreateEdit-module__middlePaneWrapper__Q3opP","milestonePageDescription":"MilestoneCreateEdit-module__milestonePageDescription__N88js"};